import styled, { css } from 'styled-components'

import { CLAMP_LINES } from './declarationClamp'

export const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 20px;
`

export const StatusText = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin: 20px 0;
  text-align: center;
  color: ${({ theme }) => theme.FontColor};
`

export const InfoSection = styled.section`
  margin-top: 20px;
`

export const InfoSectionTitle = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.FontColor};
  margin-bottom: 10px;
`

// Declaration runs: "\n" inside run text = paragraph break
export const RichRunsText = styled.p<{ $clamped?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-line;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.FontColor};
  margin-bottom: 0;

  ${({ $clamped }) =>
    $clamped &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${CLAMP_LINES};
      overflow: hidden;
    `}
`

// QRM-662: the fade needs a positioned parent of its own. Neither the clamped
// paragraph (its overflow: hidden would clip the strip) nor InfoSection nor
// ProductInfoContainer is positioned, so without this the nearest positioned
// ancestor is ProductMainContainer and the gradient paints across the bottom of
// the whole product column.
export const DeclarationBlock = styled.div`
  position: relative;
`

export const DeclarationFade = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 28px;
  pointer-events: none;
  background-image: linear-gradient(
    transparent,
    ${({ theme }) => theme.MainBackGround}
  );
`

// QRM-647 control language: a control that carries words is a 5px rectangle,
// outlined in FontColor (ItemsBorders alone measures 1.4:1 and is not a signal).
export const TextControl = styled.button`
  margin-top: 10px;
  padding: 8px 14px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.FontColor};
  background: transparent;
  color: ${({ theme }) => theme.FontColor};
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
`

// The collapsed Nährwerte header: the section title itself is the control, with
// a caret drawn in CSS — every icon in src/assets is a white <img> glyph that
// cannot be recoloured (QRM-647), so a triangle beats an asset here.
export const SectionToggle = styled.button<{ $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.FontColor};
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  cursor: pointer;

  &::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid currentColor;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'none')};
  }
`

export const SectionToggleBody = styled.div`
  margin-top: 10px;
`

// Nutrient table: Bezeichnung / Anzahl / Einheit

export const NutrientTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  overflow: hidden;
`

export const NutrientRowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 70px 70px;
  gap: 10px;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.FontColor};
  &:nth-child(even) {
    background-color: rgba(205, 205, 205, 0.15);
  }
`

export const NutrientLabelCell = styled.span`
  overflow-wrap: break-word;
`

export const NutrientAmountCell = styled.span`
  text-align: right;
  font-weight: 600;
`

export const NutrientUnitCell = styled.span`
  text-align: left;
`
